import { Card, Typography } from "antd";
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register the necessary chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const { Text, Title } = Typography;

type Props = {
  label: string;
  value: any; // Percentage value to display
  total: number; // Total value for reference
  color: string;
};

const DashboardRectangleCard: React.FC<Props> = ({
  label,
  value,
  total,
  color,
}) => {
  const data = {
    labels: ["Completed", "Remaining"], // Labels for the segments
    datasets: [
      {
        data: [value, 100 - value], // The values for each segment
        backgroundColor: [color, "#d9d9d9"], // Color for each segment
        borderWidth: 0, // Optional: removes the border around segments
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false, // Hide legend
      },
    },
    cutout: "70%", // Makes it a doughnut by cutting out the center
  };

  return (
    <Card className="dashboard-rectangle-card">
      <div className="dashboard-values">
        <div className="dashboard-values-wrapper">
          <Text className="dashboard-title">{label}</Text>
          <b className="dashboard-count">{total}</b>
        </div>
        <div className="dashboard-progress">
          <Doughnut data={data} options={options} />
          <div className="percentage-doughnut">{value}%</div>
        </div>
      </div>
    </Card>
  );
};

export default DashboardRectangleCard;
